/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-fc63c737.mjs';
import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, ref, toRefs, createVNode, mergeProps } from 'vue';
import useVModel from '../hooks/useVModel.mjs';
import { renderTNodeJSXDefault } from '../utils/render-tnode.mjs';
import props from './props.mjs';
import { Popup } from '../popup/index.mjs';
import ColorPanel from './panel/index.mjs';
import DefaultTrigger from './trigger.mjs';
import { useBaseClassName } from './hooks.mjs';
import '../_chunks/dep-2a2a0e63.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../_common/js/utils/set-style.mjs';
import '../popup/props.mjs';
import '../popup/container.mjs';
import '../_chunks/dep-56ceb7ce.mjs';
import '../hooks/useResizeObserver.mjs';
import '../_chunks/dep-fdde96c5.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import './const.mjs';
import '../_common/js/color-picker/constants.mjs';
import './panel/header.mjs';
import '../radio/index.mjs';
import '../radio/radio.mjs';
import '../utils/helper.mjs';
import '../_chunks/dep-c3626417.mjs';
import '../_chunks/dep-e00db566.mjs';
import '../_chunks/dep-961339ce.mjs';
import '../radio/props.mjs';
import '../radio/constants.mjs';
import '../form/hooks.mjs';
import '../hooks/tnode.mjs';
import '../radio/group.mjs';
import '../_chunks/dep-b6902699.mjs';
import '../_chunks/dep-b7435939.mjs';
import '../radio/radio-group-props.mjs';
import '../radio/useKeyboard.mjs';
import '../radio/radio-button.mjs';
import '../radio/type.mjs';
import './panel/linear-gradient.mjs';
import './utils/index.mjs';
import '../_common/js/color-picker/index.mjs';
import '../_common/js/color-picker/cmyk.mjs';
import '../_common/js/color-picker/color.mjs';
import '../_chunks/dep-d8a84e5f.mjs';
import '../_chunks/dep-5db111ef.mjs';
import '../_common/js/color-picker/draggable.mjs';
import '../input-number/index.mjs';
import '../input-number/input-number.mjs';
import 'tdesign-icons-vue-next';
import '../button/index.mjs';
import '../button/button.mjs';
import '../loading/index.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/helper.mjs';
import '../loading/props.mjs';
import '../hooks/useTeleport.mjs';
import '../loading/type.mjs';
import '../button/props.mjs';
import '../hooks/useRipple.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../utils/set-style.mjs';
import '../button/type.mjs';
import '../input/index.mjs';
import '../input/input.mjs';
import '../input/props.mjs';
import '../hooks/useGlobalIcon.mjs';
import '../input/useInput.mjs';
import '../form/const.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/useCommonClassName.mjs';
import '../hooks/useDefaultValue.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../input/useLengthLimit.mjs';
import '../_common/js/log/index.mjs';
import '../_common/js/log/log.mjs';
import '../input/useInputEventHandler.mjs';
import '../input/useInputWidth.mjs';
import '../input/input-group.mjs';
import '../input/input-group-props.mjs';
import '../input/type.mjs';
import '../input-number/props.mjs';
import '../input-number/useInputNumber.mjs';
import '../_common/js/input-number/number.mjs';
import '../_common/js/input-number/large-number.mjs';
import '../input-number/type.mjs';
import './panel/base-props.mjs';
import './panel/saturation.mjs';
import './panel/hue.mjs';
import './panel/slider.mjs';
import './panel/alpha.mjs';
import './panel/format/index.mjs';
import '../select/index.mjs';
import '../select/select.mjs';
import '../_chunks/dep-9c5bd9e6.mjs';
import '../_chunks/dep-30c9b83d.mjs';
import '../_chunks/dep-f2586304.mjs';
import '../_chunks/dep-f7eab885.mjs';
import '../_chunks/dep-83588d06.mjs';
import '../_chunks/dep-63c5b255.mjs';
import '../_chunks/dep-548864ce.mjs';
import '../_chunks/dep-61caab6c.mjs';
import '../_chunks/dep-a6ed5930.mjs';
import '../common-components/fake-arrow.mjs';
import '../select-input/index.mjs';
import '../select-input/select-input.mjs';
import '../select-input/props.mjs';
import '../select-input/useSingle.mjs';
import '../select-input/useMultiple.mjs';
import '../tag-input/index.mjs';
import '../tag-input/tag-input.mjs';
import '../tag-input/props.mjs';
import '../tag-input/hooks/useTagScroll.mjs';
import '../tag-input/useTagList.mjs';
import '../tag/index.mjs';
import '../tag/tag.mjs';
import '../tag/props.mjs';
import '../tag/check-tag.mjs';
import '../tag/check-tag-props.mjs';
import '../tag/type.mjs';
import '../tag-input/hooks/useHover.mjs';
import '../tag-input/hooks/useDragSorter.mjs';
import '../tag-input/type.mjs';
import '../select-input/useOverlayInnerStyle.mjs';
import '../select-input/type.mjs';
import '../select/select-panel.mjs';
import '../_chunks/dep-219a3220.mjs';
import '../select/option.mjs';
import '../select/option-props.mjs';
import '../checkbox/index.mjs';
import '../checkbox/checkbox.mjs';
import '../checkbox/props.mjs';
import '../checkbox/constants.mjs';
import '../checkbox/group.mjs';
import '../checkbox/checkbox-group-props.mjs';
import '../checkbox/type.mjs';
import '../select/helper.mjs';
import '../select/optionGroup.mjs';
import '../select/option-group-props.mjs';
import '../select/props.mjs';
import '../select/hooks/usePanelVirtualScroll.mjs';
import '../select/hooks/useSelectOptions.mjs';
import '../select/type.mjs';
import './panel/format/inputs.mjs';
import '../_chunks/dep-617caa79.mjs';
import './panel/format/config.mjs';
import './panel/swatches.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _ColorPicker = defineComponent({
  name: "TColorPicker",
  props: _objectSpread({}, props),
  setup: function setup(props2) {
    var baseClassName = useBaseClassName();
    var visible = ref(false);
    var setVisible = function setVisible(value) {
      return visible.value = value;
    };
    var _toRefs = toRefs(props2),
      inputValue = _toRefs.value,
      modelValue = _toRefs.modelValue;
    var _useVModel = useVModel(inputValue, modelValue, props2.defaultValue, props2.onChange),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      innerValue = _useVModel2[0],
      setInnerValue = _useVModel2[1];
    var refTrigger = ref();
    var renderPopupContent = function renderPopupContent() {
      if (props2.disabled) {
        return null;
      }
      var newProps = _objectSpread({}, props2);
      delete newProps.onChange;
      return createVNode(ColorPanel, mergeProps(newProps, {
        "disabled": props2.disabled,
        "value": innerValue.value,
        "togglePopup": setVisible,
        "onChange": function onChange(value, context) {
          return setInnerValue(value, context);
        }
      }), null);
    };
    return {
      baseClassName: baseClassName,
      innerValue: innerValue,
      visible: visible,
      refTrigger: refTrigger,
      renderPopupContent: renderPopupContent,
      setVisible: setVisible,
      setInnerValue: setInnerValue
    };
  },
  render: function render() {
    var _this = this;
    var popupProps = this.popupProps,
      baseClassName = this.baseClassName;
    var popProps = _objectSpread(_objectSpread({
      placement: "bottom-left"
    }, popupProps || {}), {}, {
      trigger: "click",
      attach: "body",
      overlayClassName: [baseClassName],
      visible: this.visible,
      overlayInnerStyle: {
        padding: 0
      },
      onVisibleChange: function onVisibleChange(visible, context) {
        if (context.trigger === "document") {
          _this.setVisible(false);
        }
      }
    });
    return createVNode(Popup, mergeProps(popProps, {
      "content": this.renderPopupContent
    }), {
      "default": function _default() {
        return [createVNode("div", {
          "class": "".concat(baseClassName, "__trigger"),
          "onClick": function onClick() {
            return _this.setVisible(!_this.visible);
          },
          "ref": "refTrigger"
        }, [renderTNodeJSXDefault(_this, "default", createVNode(DefaultTrigger, {
          "color": _this.innerValue,
          "disabled": _this.disabled,
          "clearable": _this.clearable,
          "input-props": _this.inputProps,
          "onTriggerChange": _this.setInnerValue
        }, null))])];
      }
    });
  }
});

export { _ColorPicker as default };
//# sourceMappingURL=color-picker.mjs.map
